export enum DownloadStatus {
    STARTING = 'starting',
    PROCESSING = 'processing',
    UPLOADING = 'uploading',
    READY = 'ready',
    FAILED = 'failed',
}

export interface DownloadItem {
    signature: string;
    name?: string;
    status: DownloadStatus;
    filesize?: number;
    total?: number;
    processed?: number;
    progress_percentage?: number;
    download_url?: string;
    completed_at?: string;
    created_at?: string;
    expires_at?: string;
    message?: string;
}

export interface DownloadsResponse extends Array<DownloadItem> {}
